import { returnNote as returnNoteEn } from '../en/returnNote';

export const returnNote = {
  ...returnNoteEn,
  returnNotes: 'ආපසු ලබාදීමේ සටහන්',
  allReturnNotes: 'සියලුම ආපසු ලබාදීමේ සටහන්',
  createReturnNote: 'ආපසු ලබාදීමේ සටහනක් සාදන්න',
  returnNoteDetails: 'ආපසු ලබාදීමේ සටහනේ විස්තර',
  status_completed: 'සම්පූර්ණයි',
  status_voided: 'අවලංගු කරන ලදී',
  void: 'අවලංගු කරන්න',
  voidReturnNote: 'ආපසු ලබාදීමේ සටහන අවලංගු කරන්න',
  creditNote: 'ණය සටහන',
  creditNoteRemaining: 'ඉතිරි ශේෂය',
  linkedCreditNotes: 'සම්බන්ධිත ණය සටහන්',
  confirmVoidReturnNote: 'මෙම ආපසු ලබාදීමේ සටහන අවලංගු කරන්නද? ආපසු ලැබුණු තොගය නැවත ඉවත් කෙරේ, ඇණවුමේ ශේෂය සහ තත්ත්වය නැවත ගණනය කෙරේ, සහ මෙම ආපසු ලබාදීමේ ණය සටහන අවලංගු කෙරේ. දැනටමත් ලබා දුන් මුදල් ආපසු ගෙවීම් අතින් අයකර ගත යුතුය.',
  voidReason: 'අවලංගු කිරීමට හේතුව',
  voidReasonPlaceholder: 'අවලංගු කිරීමට හේතුව ඇතුළත් කරන්න...',
  returnNoteVoidedSuccessfully: 'ආපසු ලබාදීමේ සටහන සාර්ථකව අවලංගු කරන ලදී',
  failedToVoidReturnNote: 'ආපසු ලබාදීමේ සටහන අවලංගු කිරීමට අසමත් විය',
};
